






















import {
  Vue,
  Component,
} from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  private get auth() {
    return this.$store.getters.authenticated;
  }

  private mounted() {
    Vue.nextTick(() => {
      this.$store.state.ui.start('#firebaseui-auth-container', this.$store.state.uiConfig);
    });
    //   console.log('this.$route.path', this.$route.query.redirect);
    //   let url = this.$route.query.redirect;
    //   this.$router.push(url);
    // // if (this.$store.getters.authenticated) {
    // // }
  }
}
